export default __webpack_public_path__ + "static/media/sendInvoice-icon.78098c7c.svg";